import { useState } from "react";
import { FaPlay, FaPause, FaChevronDown } from "react-icons/fa";

const ReplayControlPanel = ({
  togglePlay,
  speed,
  onPlayPause,
  speedFactor,
  factor = [1, 2, 4, 8, 10, 15, 20],
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showTooltip, setShowTooltip] = useState({ play: false, speed: false });

  const onToggleClick = () => {
    const value = !togglePlay;
    onPlayPause(value);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleListClick = (item) => {
    setAnchorEl(null);
    speedFactor(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="flex items-center justify-between gap-3">
      <div className="relative inline-block">
          <button
            className="flex h-10 w-10 items-center justify-center rounded-full bg-[#2f80ed] text-white shadow-[0_10px_24px_rgba(47,128,237,0.28)] transition-colors duration-200 hover:bg-[#1f6fd6]"
            onClick={onToggleClick}
            onMouseEnter={() => setShowTooltip({ ...showTooltip, play: true })}
            onMouseLeave={() => setShowTooltip({ ...showTooltip, play: false })}
            aria-label={togglePlay ? "pause" : "play"}
          >
            {togglePlay ? (
              <FaPause size={14} fill="currentColor" />
            ) : (
              <FaPlay size={14} fill="currentColor" />
            )}
          </button>

          {/* Tooltip */}
          {showTooltip.play && (
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap">
              {togglePlay ? "Pause" : "Play"}
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
            </div>
          )}
      </div>

      {/* Speed Control */}
      <div className="relative">
          <div className="relative inline-block">
            <button
              className="flex h-10 min-w-[74px] items-center justify-between rounded-2xl border border-[#d9e3f0] bg-[#f7faff] px-3 text-[15px] font-semibold text-[#2d3748] shadow-sm transition-colors duration-200 hover:bg-[#edf4ff]"
              onClick={handleClick}
              onMouseEnter={() =>
                setShowTooltip({ ...showTooltip, speed: true })
              }
              onMouseLeave={() =>
                setShowTooltip({ ...showTooltip, speed: false })
              }
              aria-haspopup="true"
            >
              <span>{`${speed}x`}</span>
              <FaChevronDown size={14} />
            </button>

            {/* Tooltip */}
            {showTooltip.speed && (
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap">
                Playback Speed
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
              </div>
            )}
          </div>

          {/* Dropdown Menu */}
          {anchorEl && (
            <>
              {/* Backdrop */}
              <div className="fixed inset-0 z-10" onClick={handleClose} />

              {/* Menu */}
              <div className="absolute right-0 top-full z-20 mt-2 min-w-full overflow-hidden rounded-2xl border border-[#d9e3f0] bg-white shadow-[0_16px_34px_rgba(15,23,42,0.14)]">
                {factor.map((item) => (
                  <button
                    key={item}
                    className="w-full px-4 py-2 text-left text-sm text-[#334155] transition-colors duration-150 hover:bg-[#f4f8ff]"
                    onClick={() => handleListClick(item)}
                  >
                    {`${item}x`}
                  </button>
                ))}
              </div>
            </>
          )}
      </div>
    </div>
  );
};

export default ReplayControlPanel;
